import { Box } from "@mui/material";
import { useParams } from "react-router-dom";

import { ServiceProvider } from "../../../../api/types/topServiceProviders.types";
import { useUserDataFormatter } from "../../../../../User/hooks/useUserDataFormatter";
import { useProfileData } from "../../../../../../hooks/useProfileData";
import { useGetServiceRequest } from "../../../../api/queries/useGetServiceRequest";

import ChatHeader from "./ChatHeader";
import ChatContainer from "./ChatContainer";
import { useEffect } from "react";
import { updateLastSeenServiceChat } from "../../../../../Chat/api/services/chat";

const ChatTab = ({
  serviceProvider,
  requester,
}: {
  serviceProvider?: ServiceProvider;
  requester?: ServiceProvider;
}) => {
  const user = serviceProvider ?? (requester as ServiceProvider);
  const { fullName, firstTwoChr, media } = useUserDataFormatter(user);

  const { data: userData } = useProfileData();
  const { serviceRequestId } = useParams();
  const { data: serviceRequest, isLoading: isServiceRequestLoading } = useGetServiceRequest(Number(serviceRequestId));
  const { firebaseChatId: threadId } = serviceRequest ?? {};

  useEffect(() => {
    if (!threadId) return;
    updateLastSeenServiceChat(threadId);
  }, [threadId]);

  if (!threadId || !userData?.id) return null;

  const currentUser = {
    id: userData.id,
    fullName: userData.fullName,
    firstTwoChr: userData.firstTwoChr,
    media: userData.media,
  };

  const otherUser = {
    id: user.id,
    fullName,
    firstTwoChr,
    media,
  };

  return (
    <Box sx={styles.container}>
      <ChatHeader user={user} />
      <ChatContainer threadId={threadId} currentUser={currentUser} otherUser={otherUser} requestId={serviceRequestId} />
    </Box>
  );
};

export default ChatTab;

const styles = {
  container: {
    flex: 1,
    borderRadius: "16px",
    border: "1px solid #EAECF0",
    background: "#FFF",
    padding: "24px 16px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
};
